module.exports = __webpack_public_path__ + "img/Lettre_decorative.152cbb2.jpg";